import { apiService } from '../../../../components/api/apiService';

const CONNECTION = 'backend_py';
const PATH = '/api/v1/vector-stores/test';

export interface VectorStoreTestResult {
  ok: boolean;
  message: string;
  collectionCount?: number | null;
}

const PROVIDER_API: Record<string, string> = {
  Pinecone: 'Pinecone',
  Qdrant: 'Qdrant',
  ChromaDB: 'Chroma',
  Weaviate: 'Weaviate',
  Milvus: 'Milvus',
  FAISS: 'FAISS',
};

function errorMessage(err: unknown): string {
  const axiosErr = err as {
    code?: string;
    response?: { data?: { error?: { message?: string }; message?: string } };
    message?: string;
  };
  const code = axiosErr.code || '';
  const raw = axiosErr.message || '';
  if (code === 'ERR_NETWORK' || raw === 'Network Error' || /ECONNREFUSED/i.test(raw)) {
    return 'Cannot reach BackendPYApp at http://127.0.0.1:8014. Start it with `python run.py` from BackendPYApp.';
  }
  return (
    axiosErr.response?.data?.error?.message ||
    axiosErr.response?.data?.message ||
    axiosErr.message ||
    'Vector store connection test failed'
  );
}

export async function testVectorStore(
  provider: string,
  endpointUrl?: string,
  apiKey?: string,
): Promise<VectorStoreTestResult> {
  try {
    const data = (await apiService.post(
      PATH,
      {
        provider: PROVIDER_API[provider] || provider,
        endpointUrl: endpointUrl?.trim() || undefined,
        apiKey: apiKey?.trim() || undefined,
      },
      CONNECTION,
    )) as VectorStoreTestResult;
    return {
      ok: Boolean(data.ok),
      message: data.message || (data.ok ? 'Connected.' : 'Connection failed.'),
      collectionCount: typeof data.collectionCount === 'number' ? data.collectionCount : null,
    };
  } catch (err) {
    throw new Error(errorMessage(err));
  }
}
